import cloneDeep from 'clone-deep'
import { Frequency } from 'components/Frequency'
import { RepeatType } from 'components/Frequency/constants'
import { validateFrequencyData } from 'components/Frequency/logic'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { updateLoanInvoice } from 'services'
import { Modal } from 'stories/components'

import type { IInvoice } from './types'

export const InvoiceFrequencyModal = ({
  item,
  onClose,
  onSaved,
}: {
  item: IInvoice
  onClose: () => void
  onSaved: () => void
}) => {
  const [loading, setLoading] = useState(false)
  const [errorCheck, setErrorCheck] = useState(false)
  const [frequency, setFrequency] = useState<Record<string, any>>(
    item.frequency || { repeatType: RepeatType.NoRepeat },
  )

  const onOk = async () => {
    setErrorCheck(true)
    if (validateFrequencyData(frequency)) return

    setLoading(true)
    await updateLoanInvoice(item.id, { frequency: cloneDeep(frequency) })
    setLoading(false)
    toast('Recurring schedule updated', { type: 'success' })
    onSaved()
  }

  return (
    <Modal
      title={`Recurring Invoice — ${item.payee || item.no || `#${item.id}`}`}
      isOpen
      loading={loading}
      onClose={onClose}
      onOk={onOk}
    >
      <div className="w-full max-w-[480px]">
        <p className="mb-3 text-sm text-gray-500">
          When set to repeat, a new unpaid invoice is created automatically on each due date.
        </p>
        <Frequency
          data={frequency}
          startDate={String(item.date || '')}
          onChange={(value: any) => setFrequency(value)}
          errorCheck={errorCheck}
        />
      </div>
    </Modal>
  )
}
